<question [title]="title" [description]="description" [valueOnly]="valueOnly">
  <ion-list *ngIf="!valueOnly" class="question-mc-list">
    <ion-item *ngFor="let option of options;let i=index;">
      <ion-checkbox slot="start" name="{{'cb' + i}}" (ionChange)="changeItem(i, $event)" [checked]="isChecked(i)" [attr.aria-label]="getOptionText(option)"></ion-checkbox>
      <ion-label class="ion-text-wrap" (click)="switch(i)">
        <div>{{getOptionText(option)}}</div>
      </ion-label>
    </ion-item>
  </ion-list>
  <ion-list *ngIf="valueOnly" class="question-mc-list">
    <ion-item *ngFor="let option of options;let i=index;" [ngClass]="isSolution(i) ? 'solution' : 'no-solution'">
      <ion-checkbox slot="start" name="{{'cb' + i}}" disabled [checked]="isChecked(i)" [attr.aria-label]="getOptionText(option)"></ion-checkbox>
      <ion-label class="ion-text-wrap">
        <div>{{getOptionText(option)}}</div>
      </ion-label>
    </ion-item>
  </ion-list>
</question>
